<template>

  <div id="HolyHeader">
    <b-navbar
      toggleable="lg"
      type="light"
    >
      <b-navbar-brand
        router-link
        to="/"
        v-if="isLoggedIn && isAdminView"
      >
        <svg
          class="logo"
          xmlns="http://www.w3.org/2000/svg"
          width="195"
          height="35"
          viewBox="0 0 1140.442 291.468"
          fill="currentColor"
        >
          <path
            d="M82 161.457V170c0 15.839-12.338 28.85-27.908 29.928a4 4 0 0 0-3.195 1.983L42.185 217c-.77 1.333.193 3 1.732 3H52c27.614 0 50-22.386 50-50V90h23v78a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V90h23v30.144c0 27.926 22.093 51.316 50.013 51.846C246.584 172.534 270 149.45 270 121V72a2 2 0 0 0-2-2h-16a2 2 0 0 0-2 2v48.34c0 16.869-13.201 31.146-30.062 31.646-17.52.52-31.938-13.58-31.938-30.986V72a2 2 0 0 0-2-2h-41V51c0-16.391 12.787-29.851 28.909-30.93a3.993 3.993 0 0 0 3.196-1.983L185.815 3c.77-1.333-.192-3-1.732-3H176c-28.166 0-51 22.833-51 51v19H51.856C23.93 70 .54 92.092.009 120.013-.533 148.583 22.55 172 51 172c11.656 0 22.403-3.939 31-10.543M82 121c0 17.094-13.906 31-31 31s-31-13.906-31-31 13.907-31 31-31h31v31M310 120.002c0-29.428 21.714-51.857 52.284-51.857 24.674 0 42.245 14.601 48.17 34.714a2.008 2.008 0 0 1-1.926 2.571h-16.54c-.817 0-1.568-.49-1.855-1.255-4.078-10.86-14.637-17.887-27.849-17.887-18.856 0-32.57 14.429-32.57 33.714 0 19.57 13.714 33.713 32.57 33.713 13.087 0 23.782-6.908 28.115-17.648.3-.74 1.039-1.209 1.838-1.209h16.894a2.009 2.009 0 0 1 1.931 2.554c-5.735 20.224-24.234 34.445-48.92 34.445-30.57 0-52.142-22.142-52.142-51.855ZM449 131.43l-33.564-58.431c-.766-1.333.197-2.996 1.734-2.996h16.082A2 2 0 0 1 435 71.03l22.856 41.113h1L481.43 71.04a2 2 0 0 1 1.753-1.037h16.513c1.536 0 2.498 1.658 1.737 2.991l-33.29 58.293V168a2 2 0 0 1-2 2H451a2 2 0 0 1-2-2v-36.57ZM516.572 72.003a2 2 0 0 1 2-2H554c20.428 0 34.428 13 34.428 31.856 0 13.857-8.143 24.428-18.714 29.142l20.316 36.016c.752 1.333-.21 2.983-1.742 2.983h-16.65a2 2 0 0 1-1.772-1.072l-18.152-34.641h-16.142V168a2 2 0 0 1-2 2h-15a2 2 0 0 1-2-2V72.003Zm36 45.999c9.428 0 16.427-5.571 16.427-16.143 0-9-6.143-15.571-16.713-15.571h-16.714v31.714h17ZM607.001 132.716V72.003a2 2 0 0 1 2-2H624a2 2 0 0 1 2 2v60.569c0 13.285 7.143 21.429 20.571 21.429 13.572 0 20.714-8.144 20.714-21.572V72.003a2 2 0 0 1 2-2h14.857a2 2 0 0 1 2 2v60.569c0 23.428-15.286 39.285-39.57 39.285-24.428 0-39.571-15.714-39.571-39.142ZM703.064 138.43h14.508c1.024 0 1.856.777 1.986 1.792 1.041 8.12 8.291 14.206 20.014 14.206 10.714 0 17.572-4.57 17.572-12.142 0-22.857-53.142-4.428-53.142-45.284 0-15.857 12.571-28.857 34.57-28.857 18.327 0 33.994 9.304 35.595 28.68a2.012 2.012 0 0 1-2 2.177h-15.022c-1.022 0-1.857-.775-1.983-1.789-.91-7.288-6.666-12.068-16.59-12.068-10.57 0-15.713 5.285-15.713 11.572 0 20.856 53.855 3.714 53.855 44.141 0 17.713-13.714 31-37.713 31-22.029 0-36.892-12.607-37.94-31.296a2.014 2.014 0 0 1 2.003-2.133ZM849.15 70.003h21.035a2 2 0 0 1 1.883 1.327l34.286 95.997A2 2 0 0 1 904.47 170h-15.892a2 2 0 0 1-1.885-1.331l-6.527-18.383h-41.57l-6.39 18.37a2 2 0 0 1-1.89 1.344h-15.314a2 2 0 0 1-1.885-2.67l34.148-95.998a2 2 0 0 1 1.884-1.33Zm25.587 63.284-14.714-42.142h-1.143l-14.714 42.142h30.57ZM912.026 120.002c0-29.428 21.714-51.857 52.284-51.857 24.174 0 41.688 13.84 47.925 32.659.428 1.292-.547 2.626-1.908 2.626h-16.844c-.799 0-1.502-.484-1.836-1.21-4.304-9.36-14.046-15.932-27.337-15.932-19.735 0-32.787 14.671-32.568 34.199.218 19.356 16.009 34.82 35.326 33.573 14.957-.966 25.89-10.178 27.241-22.202h-29.713a2 2 0 0 1-2-2v-11.714a2 2 0 0 1 2-2h48.877c1.096 0 2.003.884 2.003 1.98.008 34.203-21.588 53.733-51.023 53.733-30.713 0-52.427-22.142-52.427-51.855ZM501.541 282.179h-.64v7.901h-11v-80.086h11.213v32.355h.747c1.708-2.883 7.581-9.503 18.26-9.503 15.484 0 26.588 12.173 26.588 29.472s-11.104 29.15-27.122 29.15c-11.106 0-16.55-7.154-18.046-9.29Zm33.743-19.969c0-11.212-7.048-19.113-17.192-19.113-9.823 0-17.299 7.047-17.299 19.113 0 10.571 6.514 19.114 17.192 19.114 10.251 0 17.3-7.474 17.3-19.114ZM554.294 218.323c0-4.057 3.097-7.048 7.262-7.048 4.377 0 7.474 2.99 7.474 7.048 0 4.272-3.096 7.155-7.474 7.155-4.165 0-7.262-2.883-7.262-7.155Zm1.601 15.91h11.213v55.847h-11.212v-55.847ZM583.232 276.198v-66.204h11.213v65.564c0 2.99 1.494 4.591 4.27 4.591h2.457v9.931h-4.698c-8.436 0-13.242-5.125-13.242-13.882ZM607.58 262.317c0-17.298 10.998-29.471 26.481-29.471 10.68 0 16.552 6.62 18.26 9.503h.747v-32.355h11.213v80.086H653.39v-7.901h-.748c-1.495 2.134-6.834 9.289-18.046 9.289-16.018 0-27.016-11.853-27.016-29.15Zm45.81-.107c0-12.066-7.476-19.113-17.3-19.113-10.144 0-17.084 7.901-17.084 19.113 0 11.64 6.94 19.114 17.299 19.114 10.57 0 17.085-8.543 17.085-19.114ZM702.405 291.468c-16.764 0-27.976-12.386-27.976-29.15 0-17.726 11.96-29.472 27.762-29.472 17.513 0 27.444 12.813 27.444 28.723v4.165H685.64c.427 9.717 6.941 16.337 17.085 16.337 6.407 0 12.493-3.203 14.736-7.368l8.115 5.553c-4.592 6.834-12.493 11.212-23.172 11.212Zm-.214-49.226c-8.542 0-15.482 6.087-16.336 14.843h32.568c-.748-9.396-7.475-14.843-16.231-14.843ZM746.402 272.354v-28.937h-10.037v-9.076h7.367c1.923 0 3.31-1.389 3.31-3.631v-12.28h10.572v15.803h16.23v9.184h-16.23v28.617c0 5.339 2.242 8.542 8.115 8.542h7.582v9.504h-9.29c-10.999 0-17.619-6.087-17.619-17.726ZM806.096 234.233h11.959l11.319 42.606h.747l13.348-42.606h11.852l13.241 42.606h.748l11.532-42.606h11.853l-16.551 55.847h-13.348l-13.027-41.43h-.641l-13.134 41.43H822.54l-16.444-55.847ZM923.986 291.468c-16.764 0-27.976-12.386-27.976-29.15 0-17.726 11.96-29.472 27.762-29.472 17.513 0 27.444 12.813 27.444 28.723v4.165h-43.994c.427 9.717 6.94 16.337 17.085 16.337 6.407 0 12.493-3.203 14.736-7.368l8.115 5.553c-4.592 6.834-12.494 11.212-23.172 11.212Zm-.213-49.226c-8.542 0-15.483 6.087-16.337 14.843h32.568c-.748-9.396-7.475-14.843-16.231-14.843ZM960.936 218.323c0-4.057 3.096-7.048 7.261-7.048 4.378 0 7.475 2.99 7.475 7.048 0 4.272-3.097 7.155-7.475 7.155-4.165 0-7.261-2.883-7.261-7.155Zm1.601 15.91h11.213v55.847h-11.213v-55.847ZM993.185 272.354v-28.937h-10.037v-9.076h7.367c1.923 0 3.31-1.389 3.31-3.631v-12.28h10.572v15.803h16.23v9.184h-16.23v28.617c0 5.339 2.242 8.542 8.115 8.542h7.582v9.504h-9.29c-11 0-17.62-6.087-17.62-17.726ZM1055.867 291.468c-16.764 0-27.976-12.386-27.976-29.15 0-17.726 11.96-29.472 27.762-29.472 17.513 0 27.444 12.813 27.444 28.723v4.165h-43.994c.427 9.717 6.94 16.337 17.085 16.337 6.407 0 12.493-3.203 14.736-7.368l8.115 5.553c-4.592 6.834-12.494 11.212-23.172 11.212Zm-.214-49.226c-8.542 0-15.482 6.087-16.337 14.843h32.569c-.748-9.396-7.475-14.843-16.232-14.843ZM1094.418 234.233h10.785v9.718h.748c1.708-4.485 7.047-9.824 14.95-9.824h4.911v10.892h-5.232c-9.397 0-14.95 7.154-14.95 17.511v27.55h-11.212v-55.847ZM1126.348 284.527c0-3.95 3.203-7.048 7.047-7.048 4.057 0 7.048 3.097 7.048 7.048s-2.99 6.94-7.048 6.94c-3.844 0-7.047-2.989-7.047-6.94Z"
          />
        </svg>
      </b-navbar-brand>

      <b-collapse
        id="nav-collapse-admin"
        is-nav
        v-if="isLoggedIn && isAdminView"
      >
        <b-navbar-nav>
          <b-nav-item
            router-link
            to="/admin/offer-list"
            @click="setFilters({ filter: '' })"
          >
            <i class="material-icons"></i> Übersicht
          </b-nav-item>
          <b-nav-item
            :href="offerLink()"
            target="_blank"
            v-if="isOfferView"
          >
            <i class="material-icons"></i> Kundenansicht
          </b-nav-item>
          <b-nav-item
            href="#"
            @click="copyLink()"
            v-if="isOfferView"
          >
            <i class="material-icons"></i> Link kopieren
          </b-nav-item>
          <b-nav-item
            :href="emailLink"
            v-if="isOfferView"
          >
            <i class="material-icons"></i> E-Mail öffnen
          </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item
            to="/admin/logout"
            v-if="isLoggedIn && isAdminView"
          >
            <i class="material-icons"></i> Logout
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>

      <b-container v-if="!isAdminView">
        <div class="d-flex mr-auto">
          <b-link
            href="https://www.gfu.net"
            class="navbar-brand"
          >
            <svg
              class="logo"
              xmlns="http://www.w3.org/2000/svg"
              width="195"
              height="50"
              viewBox="0 0 1140.442 291.468"
              fill="currentColor"
            >
              <path
                d="M82 161.457V170c0 15.839-12.338 28.85-27.908 29.928a4 4 0 0 0-3.195 1.983L42.185 217c-.77 1.333.193 3 1.732 3H52c27.614 0 50-22.386 50-50V90h23v78a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V90h23v30.144c0 27.926 22.093 51.316 50.013 51.846C246.584 172.534 270 149.45 270 121V72a2 2 0 0 0-2-2h-16a2 2 0 0 0-2 2v48.34c0 16.869-13.201 31.146-30.062 31.646-17.52.52-31.938-13.58-31.938-30.986V72a2 2 0 0 0-2-2h-41V51c0-16.391 12.787-29.851 28.909-30.93a3.993 3.993 0 0 0 3.196-1.983L185.815 3c.77-1.333-.192-3-1.732-3H176c-28.166 0-51 22.833-51 51v19H51.856C23.93 70 .54 92.092.009 120.013-.533 148.583 22.55 172 51 172c11.656 0 22.403-3.939 31-10.543M82 121c0 17.094-13.906 31-31 31s-31-13.906-31-31 13.907-31 31-31h31v31M310 120.002c0-29.428 21.714-51.857 52.284-51.857 24.674 0 42.245 14.601 48.17 34.714a2.008 2.008 0 0 1-1.926 2.571h-16.54c-.817 0-1.568-.49-1.855-1.255-4.078-10.86-14.637-17.887-27.849-17.887-18.856 0-32.57 14.429-32.57 33.714 0 19.57 13.714 33.713 32.57 33.713 13.087 0 23.782-6.908 28.115-17.648.3-.74 1.039-1.209 1.838-1.209h16.894a2.009 2.009 0 0 1 1.931 2.554c-5.735 20.224-24.234 34.445-48.92 34.445-30.57 0-52.142-22.142-52.142-51.855ZM449 131.43l-33.564-58.431c-.766-1.333.197-2.996 1.734-2.996h16.082A2 2 0 0 1 435 71.03l22.856 41.113h1L481.43 71.04a2 2 0 0 1 1.753-1.037h16.513c1.536 0 2.498 1.658 1.737 2.991l-33.29 58.293V168a2 2 0 0 1-2 2H451a2 2 0 0 1-2-2v-36.57ZM516.572 72.003a2 2 0 0 1 2-2H554c20.428 0 34.428 13 34.428 31.856 0 13.857-8.143 24.428-18.714 29.142l20.316 36.016c.752 1.333-.21 2.983-1.742 2.983h-16.65a2 2 0 0 1-1.772-1.072l-18.152-34.641h-16.142V168a2 2 0 0 1-2 2h-15a2 2 0 0 1-2-2V72.003Zm36 45.999c9.428 0 16.427-5.571 16.427-16.143 0-9-6.143-15.571-16.713-15.571h-16.714v31.714h17ZM607.001 132.716V72.003a2 2 0 0 1 2-2H624a2 2 0 0 1 2 2v60.569c0 13.285 7.143 21.429 20.571 21.429 13.572 0 20.714-8.144 20.714-21.572V72.003a2 2 0 0 1 2-2h14.857a2 2 0 0 1 2 2v60.569c0 23.428-15.286 39.285-39.57 39.285-24.428 0-39.571-15.714-39.571-39.142ZM703.064 138.43h14.508c1.024 0 1.856.777 1.986 1.792 1.041 8.12 8.291 14.206 20.014 14.206 10.714 0 17.572-4.57 17.572-12.142 0-22.857-53.142-4.428-53.142-45.284 0-15.857 12.571-28.857 34.57-28.857 18.327 0 33.994 9.304 35.595 28.68a2.012 2.012 0 0 1-2 2.177h-15.022c-1.022 0-1.857-.775-1.983-1.789-.91-7.288-6.666-12.068-16.59-12.068-10.57 0-15.713 5.285-15.713 11.572 0 20.856 53.855 3.714 53.855 44.141 0 17.713-13.714 31-37.713 31-22.029 0-36.892-12.607-37.94-31.296a2.014 2.014 0 0 1 2.003-2.133ZM849.15 70.003h21.035a2 2 0 0 1 1.883 1.327l34.286 95.997A2 2 0 0 1 904.47 170h-15.892a2 2 0 0 1-1.885-1.331l-6.527-18.383h-41.57l-6.39 18.37a2 2 0 0 1-1.89 1.344h-15.314a2 2 0 0 1-1.885-2.67l34.148-95.998a2 2 0 0 1 1.884-1.33Zm25.587 63.284-14.714-42.142h-1.143l-14.714 42.142h30.57ZM912.026 120.002c0-29.428 21.714-51.857 52.284-51.857 24.174 0 41.688 13.84 47.925 32.659.428 1.292-.547 2.626-1.908 2.626h-16.844c-.799 0-1.502-.484-1.836-1.21-4.304-9.36-14.046-15.932-27.337-15.932-19.735 0-32.787 14.671-32.568 34.199.218 19.356 16.009 34.82 35.326 33.573 14.957-.966 25.89-10.178 27.241-22.202h-29.713a2 2 0 0 1-2-2v-11.714a2 2 0 0 1 2-2h48.877c1.096 0 2.003.884 2.003 1.98.008 34.203-21.588 53.733-51.023 53.733-30.713 0-52.427-22.142-52.427-51.855ZM501.541 282.179h-.64v7.901h-11v-80.086h11.213v32.355h.747c1.708-2.883 7.581-9.503 18.26-9.503 15.484 0 26.588 12.173 26.588 29.472s-11.104 29.15-27.122 29.15c-11.106 0-16.55-7.154-18.046-9.29Zm33.743-19.969c0-11.212-7.048-19.113-17.192-19.113-9.823 0-17.299 7.047-17.299 19.113 0 10.571 6.514 19.114 17.192 19.114 10.251 0 17.3-7.474 17.3-19.114ZM554.294 218.323c0-4.057 3.097-7.048 7.262-7.048 4.377 0 7.474 2.99 7.474 7.048 0 4.272-3.096 7.155-7.474 7.155-4.165 0-7.262-2.883-7.262-7.155Zm1.601 15.91h11.213v55.847h-11.212v-55.847ZM583.232 276.198v-66.204h11.213v65.564c0 2.99 1.494 4.591 4.27 4.591h2.457v9.931h-4.698c-8.436 0-13.242-5.125-13.242-13.882ZM607.58 262.317c0-17.298 10.998-29.471 26.481-29.471 10.68 0 16.552 6.62 18.26 9.503h.747v-32.355h11.213v80.086H653.39v-7.901h-.748c-1.495 2.134-6.834 9.289-18.046 9.289-16.018 0-27.016-11.853-27.016-29.15Zm45.81-.107c0-12.066-7.476-19.113-17.3-19.113-10.144 0-17.084 7.901-17.084 19.113 0 11.64 6.94 19.114 17.299 19.114 10.57 0 17.085-8.543 17.085-19.114ZM702.405 291.468c-16.764 0-27.976-12.386-27.976-29.15 0-17.726 11.96-29.472 27.762-29.472 17.513 0 27.444 12.813 27.444 28.723v4.165H685.64c.427 9.717 6.941 16.337 17.085 16.337 6.407 0 12.493-3.203 14.736-7.368l8.115 5.553c-4.592 6.834-12.493 11.212-23.172 11.212Zm-.214-49.226c-8.542 0-15.482 6.087-16.336 14.843h32.568c-.748-9.396-7.475-14.843-16.231-14.843ZM746.402 272.354v-28.937h-10.037v-9.076h7.367c1.923 0 3.31-1.389 3.31-3.631v-12.28h10.572v15.803h16.23v9.184h-16.23v28.617c0 5.339 2.242 8.542 8.115 8.542h7.582v9.504h-9.29c-10.999 0-17.619-6.087-17.619-17.726ZM806.096 234.233h11.959l11.319 42.606h.747l13.348-42.606h11.852l13.241 42.606h.748l11.532-42.606h11.853l-16.551 55.847h-13.348l-13.027-41.43h-.641l-13.134 41.43H822.54l-16.444-55.847ZM923.986 291.468c-16.764 0-27.976-12.386-27.976-29.15 0-17.726 11.96-29.472 27.762-29.472 17.513 0 27.444 12.813 27.444 28.723v4.165h-43.994c.427 9.717 6.94 16.337 17.085 16.337 6.407 0 12.493-3.203 14.736-7.368l8.115 5.553c-4.592 6.834-12.494 11.212-23.172 11.212Zm-.213-49.226c-8.542 0-15.483 6.087-16.337 14.843h32.568c-.748-9.396-7.475-14.843-16.231-14.843ZM960.936 218.323c0-4.057 3.096-7.048 7.261-7.048 4.378 0 7.475 2.99 7.475 7.048 0 4.272-3.097 7.155-7.475 7.155-4.165 0-7.261-2.883-7.261-7.155Zm1.601 15.91h11.213v55.847h-11.213v-55.847ZM993.185 272.354v-28.937h-10.037v-9.076h7.367c1.923 0 3.31-1.389 3.31-3.631v-12.28h10.572v15.803h16.23v9.184h-16.23v28.617c0 5.339 2.242 8.542 8.115 8.542h7.582v9.504h-9.29c-11 0-17.62-6.087-17.62-17.726ZM1055.867 291.468c-16.764 0-27.976-12.386-27.976-29.15 0-17.726 11.96-29.472 27.762-29.472 17.513 0 27.444 12.813 27.444 28.723v4.165h-43.994c.427 9.717 6.94 16.337 17.085 16.337 6.407 0 12.493-3.203 14.736-7.368l8.115 5.553c-4.592 6.834-12.494 11.212-23.172 11.212Zm-.214-49.226c-8.542 0-15.482 6.087-16.337 14.843h32.569c-.748-9.396-7.475-14.843-16.232-14.843ZM1094.418 234.233h10.785v9.718h.748c1.708-4.485 7.047-9.824 14.95-9.824h4.911v10.892h-5.232c-9.397 0-14.95 7.154-14.95 17.511v27.55h-11.212v-55.847ZM1126.348 284.527c0-3.95 3.203-7.048 7.047-7.048 4.057 0 7.048 3.097 7.048 7.048s-2.99 6.94-7.048 6.94c-3.844 0-7.047-2.989-7.047-6.94Z"
              />
            </svg>
          </b-link>
        </div>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse
          id="nav-collapse"
          is-nav
          v-if="!is404"
        >
          <b-navbar-nav class="ml-auto">
            <b-nav-item
              href="#"
              @click.prevent="printPdf()"
              data-gtm-print-nav
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="currentColor" style="margin-top:-.2em;"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"/></svg>
              {{ $t('actions.print') }}
            </b-nav-item>
            <b-nav-item
              :href="pdfLink"
              target="_blank"
              data-gtm-pdf-nav
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="19px" viewBox="0 0 24 24" width="18px" fill="currentColor" style="margin-top:-.2em;"><path d="M0 0h24v24H0z" fill="none"/><path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4l6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2h7zm-1 7h5.5L14 6.5V12z"/></svg>
              {{ $t('actions.downloadPdf') }}
            </b-nav-item>
            <b-nav-item
              :href="replyMail"
              data-gtml-mail-nav
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="currentColor" style="margin-top:-.2em;"><path d="M0 0h24v24H0z" fill="none"/><path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"/></svg>
              {{ $t('actions.reply') }}
            </b-nav-item>
            <b-nav-item
              :href="forwardMail"
              data-gtml-mail-forward-nav
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="currentColor" style="margin-top:-.2em;"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
              {{ $t('actions.forward') }}
            </b-nav-item>
            <b-nav-item
              href="#"
              @click.prevent="openChat()"
              class="chat-indicator"
              :class="{ 'online': isChatOnline }"
              data-gtm-chat-nav
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="currentColor" style="margin-top:-.1em;"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"/></svg>
              {{ $t('actions.liveChat') }}
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
        <b-collapse
          id="nav-collapse"
          is-nav
          v-if="is404"
        >
          <b-navbar-nav class="ml-auto">
            <b-nav-item :href="supportMail">
              <i class="material-icons"></i> {{ $t('actions.emailSupport') }}
            </b-nav-item>
            <b-nav-item
              href="#"
              @click.prevent="openChat()"
              class="chat-indicator"
              :class="{ 'online': isChatOnline }"
              data-gtm-chat-nav
            >
              <i class="material-icons"></i> {{ $t('actions.liveChat') }}
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>

    <div style="height: 50px"></div> <!-- Spacer -->
  </div>
</template>

<script>

import Auth from '../../misc/Auth.js';
import Config from '../../misc/Config.js';
import { mapMutations, mapGetters } from 'vuex';

export default {
  name: 'Header',
  props: {
    isChatOnline: Boolean,
  },
  data() {
    return {
      isLoggedIn: false,
      isOfferView: false,
      isAdminView: false,
      is404: false,
      isBusy: false,
    }
  },
  computed: {
    ...mapGetters(['offer', 'selectedTab']),
    pdfLink() {
      return `${Config.PDF_API_URL}/pdf/${this.getPdfPath()}`
    },
    replyMail() {
      if (this.offer) {
        return `mailto:${this.offer.employee.email}?subject=${encodeURIComponent(this.$t('mail.replySubject', { title: this.offer.seminar.title, customerNumber: this.offer.contact.company.ref_id }))}`
      }
    },
    forwardMail() {
      if (this.offer) {
        return `mailto:?body=${encodeURIComponent(window.location.origin + '/offer/' + this.offer.hash)}&subject=${encodeURIComponent(this.$t('mail.forwardSubject', { title: this.offer.seminar.title }))}`
      }
    },
    supportMail() {
      return `mailto:info@gfu.net?subject=${encodeURIComponent(this.$t('mail.notFoundSubject', { path: this.$router.currentRoute.fullPath }))}`
    },
    emailLink() {
      if (this.offer) {
        return 'mailto:?body=' + window.location.origin + '/offer/' + this.offer.hash + '&subject=Angebot ' + this.offer.seminar.title;
      }
    },
  },
  methods: {
    ...mapMutations(['setFilters']),
    offerLink: function () {
      return '/offer/' + this.$route.params.offerHash;
    },
    getPdfPath() {
      return `${this.$route.params.offerHash}${(this.selectedTab) ? '_' + this.selectedTab : ''}`;
    },
    copyLink() {
      let container = this.$refs.container
      this.$copyText(window.location.origin + '/offer/' + this.$route.params.offerHash, container)
    },
    setState() {
      this.isLoggedIn = Auth.isLoggedIn();
      this.isOfferView = this.$router.currentRoute.fullPath.split('/')
        .some(path => path === 'offer');
      this.isAdminView = this.$router.currentRoute.fullPath.split('/')
        .some(path => (path === 'admin'));
      this.is404 = this.$router.currentRoute.fullPath.split('/')
        .some(path => (path === "404"));
    },
    printPdf() {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = `${Config.PDF_API_URL}/pdf/${this.getPdfPath()}`;
      document.body.appendChild(iframe);
      iframe.contentWindow.print();
    },
    openChat() {
      let url = 'https://messenger.providesupport.com/messenger/0af9vnyn0kchv09maiwenbeceg.html';
      window.open(url, '_blank', 'menubar=0,location=0,scrollbars=auto,resizable=1,status=0,width=600,height=550');
    },
  },
  mounted: function () {
    this.setState();
  },
  watch: {
    $route(to, from) {
      this.setState();
    }
  }
}
</script>

<style scoped>
.navbar {
  background-color: #dceeeb;
  color: rgb(3, 56, 120) !important;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  box-shadow: 0 1px 5px rgba(0, 0, 0, .3);
  position: fixed;
}

.navbar .logo {
  fill: rgb(3, 56, 120);
}

.navbar a {
  color: rgb(3, 56, 120) !important;
  text-transform: uppercase;
  font-weight: 500;
  font-size: .95em;
  text-decoration: none;
}

.navbar-brand img {
  height: 22px;
  width: auto;
  margin-right: 50px;
}

.nav-item a i {
  vertical-align: middle;
  padding-bottom: 2px;
  font-size: 1.3em;
}

.navbar-expand-lg .navbar-nav .nav-link {
  padding-left: 1em;
  padding-right: 1em;
}
</style>
